<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :edit.sync="edit"
        :meta="meta"
        :StuffToEatDetails="StuffToEatDetails">
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">

      <nuttrema-loader v-if="StuffToEatDetails.fetching || StuffToEatAllergenDeclaration.fetching || AllergensList.fetching"></nuttrema-loader>

      <form-stuff-to-eat-allergens
         v-else
        :edit.sync="edit"
        :AllergensList="AllergensList"
        :SettingsPresets="SettingsPresets"
        :StuffToEatDetails="StuffToEatDetails"
        :StuffToEatAllergenDeclaration="StuffToEatAllergenDeclaration"
        :SettingsPresetDetails="SettingsPresetDetails"
        @submit="onFormSubmit"
        @savePreset="onSavePreset"
        @deletePreset="onDeletePreset"
        @setAllergensManualControl="onSetAllergensManualControl"
        @recreateAllergenDeclaration="onRecreateAllergenDeclaration">
      </form-stuff-to-eat-allergens>

    </template>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';
import PageProps from 'components/mixins/page-props';

import { SETTINGS_PRESETS_KEYS } from 'constants/types';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import FormStuffToEatAllergens from './form-stuff-to-eat-allergens';

const ALLERGENS_PRESETS_TYPE = SETTINGS_PRESETS_KEYS.allergens;

export default {
  name: 'page-stuff-to-eat-allergens',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContent,
    FormStuffToEatAllergens,
    StuffToEatStandardHeader,
  },
  data: () => ({
    edit: false,
    allergensPresetID: -1,
  }),
  computed: {
    AllergensList() {
      return this.$store.getters.AllergensList;
    },
    SettingsPresets() {
      return this.$store.getters.SettingsPresets(ALLERGENS_PRESETS_TYPE);
    },
    SettingsPresetDetails() {
      return this.$store.getters.SettingsPresetDetails(this.allergensPresetID);
    },
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatAllergenDeclaration() {
      return this.$store.getters.StuffToEatAllergenDeclaration(this.id);
    },
  },
  methods: {
    ...mapActions([
      'SaveSettingsPreset',
      'DeleteSettingsPreset',
      'SetAllergensManualControl',
      'AddStuffToEatAllergenDeclaration',
      'RecreateStuffToEatAllergenDeclaration',
    ]),
    onFormSubmit(payload) {
      console.log(payload);
      this.AddStuffToEatAllergenDeclaration({
        id: this.id,
        type: this.type,
        payload,
      }).then(() => {
        console.log('save was successfully!');
        this.successNotification({ label: 'label.allergens', message: 'message.default_success_added_message' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.allergens', message: 'message.default_error_added_message' });
      });
    },
    onSavePreset(payload) {
      console.log(payload);
      this.SaveSettingsPreset({
        id: this.allergensPresetID,
        type: ALLERGENS_PRESETS_TYPE,
        payload,
      }).then(() => {
        console.log('save was successfully!');
        this.successNotification({ label: 'label.preset', message: 'message.default_success_added_message' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.preset', message: 'message.default_error_added_message' });
      });
    },
    onDeletePreset(id) {
      console.log('onDeletePreset', id);
      this.DeleteSettingsPreset({
        id,
        type: ALLERGENS_PRESETS_TYPE,
      }).then(() => {
        console.log('delete was successfully!');
        this.successNotification({ label: 'label.preset', message: 'message.default_success_delete_message' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.preset', message: 'message.default_error_delete_message' });
      });
    },
    onSetAllergensManualControl(params) {
      this.$store.dispatch('SetAllergensManualControl', {
        id: this.id,
        type: this.type,
        reload: params.reload,
        payload: {
          manual_allergens: params.manual_allergens,
        },
      });
    },
    onRecreateAllergenDeclaration(payload) {
      this.$store.dispatch('RecreateStuffToEatAllergenDeclaration', {
        id: this.id,
        type: this.type,
        payload,
      });
    },
  },
  created() {
    this.$store.dispatch('GetAllergensList', { parameters: { context: 'use' } });
    this.$store.dispatch('GetStuffToEatAllergenDeclaration', { id: this.id, type: this.type });
    this.$store.dispatch('GetSettingsPresets', { type: ALLERGENS_PRESETS_TYPE });
    this.$store.dispatch('InitStateSettingsPresetDetails', { id: this.allergensPresetID });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearAllergensList');
    this.$store.dispatch('ClearStuffToEatAllergenDeclaration', { id: this.id });
    this.$store.dispatch('ClearSettingsPresets', { type: ALLERGENS_PRESETS_TYPE });
    this.$store.dispatch('ClearSettingsPresetDetails', { id: this.allergensPresetID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/allergens/page-stuff-to-eat-allergens.vue